export const UserManagement_TABLE_TITLE = 'Unassigned Client Accounts';
export const UserManagement_TABLE_INFO_URL = '';
